import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppRedirectService } from '../../../services/app-redirect.service';
import { TranslationService } from '../../../services/translation.service';


@Component({
    selector: 'app-app-fallback-redirect',
    standalone: true,
    imports: [],
    templateUrl: './app-fallback-redirect.component.html',
    styleUrl: './app-fallback-redirect.component.scss'
})
export class AppFallbackRedirectComponent implements OnDestroy, AfterViewInit {
    isLoading: boolean = false;
    didHide = false;
    private visibilityHandler!: () => void;
    private timeoutRef: any;

    constructor(
        private readonly _translationService: TranslationService,
        private readonly _appRedirectService: AppRedirectService,
        private readonly _router: Router,
        private readonly _route: ActivatedRoute,
    ) {}

    ngAfterViewInit(): void {
        this.isLoading = true;
        this._translationService.fetchConfigDetails().subscribe({
            next: (response: any) => {
                if (!response) {
                    this.isLoading = false;
                    this.navigateBack();
                    return;
                }
                this._translationService.cpConfig = response;
                this._appRedirectService.getSmartBannerLinks();
                this.isLoading = false;
                this.didHide = false;
                this.visibilityHandler = () => {
                    if (document.hidden) {
                        this.didHide = true;
                    }
                };
                document.addEventListener('visibilitychange', this.visibilityHandler);

                // Fallback to App Store if app did NOT open
                this.timeoutRef = setTimeout(() => {
                    document.removeEventListener('visibilitychange', this.visibilityHandler);

                    if (!this.didHide) {
                        // Replace with your App Store URL
                        this._appRedirectService.redirectUserToStoreBasedOnDeviceRegion();
                        this.navigateBack();
                    }
                }, 2000);
            },
            error: () => {
                this.isLoading = false;
                this.navigateBack();
            },
        });
    }

    private navigateBack(): void {
        const routeUrl = localStorage.getItem('routeUrl');
        const langId = this._route.parent?.snapshot.paramMap.get('langId') ?? 'en-GB';
        if (routeUrl?.includes('/verify/')) {
            sessionStorage.setItem('screen', 'showThankYouPage');
            this._router.navigate([routeUrl]);
        } else {
            this._router.navigate([routeUrl ?? `/${langId}/stories`]);
        }
    }

    ngOnDestroy(): void {
        document.removeEventListener('visibilitychange', this.visibilityHandler);
        if (this.timeoutRef) {
            clearTimeout(this.timeoutRef);
        }
    }
}
